import { Helmet } from 'react-helmet-async';
import { Grid } from '@mui/material';
import { EmailsView } from '../../../components/dashboard/admin/emails';

// ----------------------------------------------------------------------

export default function Emails() {
  return (
    <>
      <Helmet>
        <title>Admin Emails | Platform Solutions</title>
      </Helmet>

      <Grid item xl={12}>
        <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="flex-start">
          <EmailsView />
        </Grid>
      </Grid>
    </>
  );
}
